module.exports = __webpack_public_path__ + "static/media/cover.22bcc8d7.png";